module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tg6OHk/tc-custom/9781683355526.jpg?1726454432806",
      "alt": "This image is the cover for the book Novel Living"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Novel Living\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this digital age, the fate of physical books remains in question. Even the concept of curling up with a good book conjures new images. But there remains a sensory thrill to physical books—to seeing and feeling them, to turning their pages—that makes many of us value them even more as digital reading grows in popularity. In Novel Living, artist Lisa Occhipinti celebrates her love for physical books by presenting us with her unique ideas for collecting and displaying them, for conserving and preserving them, and for crafting with them. Guided by Occhipinti’s artful eye, you’ll be inspired to build and display collections based on your personal passions and to use books for crafting, either by deconstructing or by copying favorite elements. Amazingly, most of the projects—ranging from easy shelving to a headboard constructed of book spines to napkins composed of scans of favorite text passages from books—require no special skills or supplies.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Occhipinti, Thayer Allyson Gowdy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lisa Occhipinti is an artist and teacher and the author of The Repurposed Library. Her work has been featured in the Boston Globe, the New York Times, Associated Press, and Wired, and on Apartment Therapy. She sells her work on Etsy under the name Shophouse.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ABRAMS\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0